import createIcon from '../../createIcon';

/**
 * @component @name CropSquare
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggNEg2QzQuOSA0IDQgNC45IDQgNlYxOEM0IDE5LjEgNC45IDIwIDYgMjBIMThDMTkuMSAyMCAyMCAxOS4xIDIwIDE4VjZDMjAgNC45IDE5LjEgNCAxOCA0Wk0xOCAxOEg2VjZIMThWMThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CropSquare = createIcon('CropSquare', [
  [
    'path',
    {
      d: 'M18 4H6C4.9 4 4 4.9 4 6V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V6C20 4.9 19.1 4 18 4ZM18 18H6V6H18V18Z',
      key: '156xkg',
    },
  ],
]);

export default CropSquare;
